import React from "react";
import './HeaderAll.css';
import HeaderTopLogo from '../../../static/img/Header/profiforexLogo.svg';
import menuMiddle from '../../../static/img/Header/menuMiddle.svg';
import TwitterLogo from '../../../static/img/Header/twitter.svg';
import CheckLanguage from "./CheckLanguage/CheckLanguage";
import CabinetHeader from "./CabinetHeader/CabinetHeader";
import HeaderSmallDivsOne from "./HeaderSmallDivs/HeaderSmallDivs";
import ChangeLink from "../../ChangeLink/ChangeLink";


function HeaderAllGatsby(props) {
    // console.log('HeaderAllGatsby',props.lang)
    function TextSource(info) {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*' + info.children}</>} catch (err) {return <>*{info.children}</>}}

    return (
    <header className="HeaderAll StandartPage">
        <div className="HeaderTop">
            <div className="HeaderTopLogo"><ChangeLink lang = {props.lang} to={'/'}> <img src={HeaderTopLogo}  alt='Ifyoudontseeimages' width='100px'/></ChangeLink></div>
            <div className="HeaderThreeButtons">
                <div className="HeaderThreeButtonsElement"><ChangeLink lang = {props.lang} to={'/account/open'}><TextSource ArrIndex= 'LayoutMain0000'>Open a trading account</TextSource> </ChangeLink></div>
                <img src={menuMiddle}  alt='Ifyoudontseeimages' width='13px'/>
                <div className="HeaderThreeButtonsElement"><ChangeLink lang = {props.lang} to={'/funds/deposit'}><TextSource ArrIndex= 'LayoutMain0005'>Deposit funds</TextSource> </ChangeLink></div>
                <img src={menuMiddle}  alt='Ifyoudontseeimages' width='13px'/>
                <div className="HeaderThreeButtonsElement"><ChangeLink lang = {props.lang} to={'/funds/withdraw'}><TextSource ArrIndex= 'LayoutMain0010'>Withdraw funds</TextSource> </ChangeLink></div>
            </div>
            <div className="HeaderTwitter"><a href="https://twitter.com/Profiforex1" target='_blank' rel="noopener noreferrer" ><img src={TwitterLogo}  alt='Ifyoudontseeimages' height='18px'/></a></div>

            <CheckLanguage lang = {props.lang}/>
            <CabinetHeader lang = {props.lang} />
            <HeaderSmallDivsOne  lang={props.lang} Active={props.Active}/>
        </div>



    </header>
)}

export default HeaderAllGatsby
